import { updateRole } from 'ducks/auth_roles'
import { clearLineItems } from 'ducks/orderComponents'
import { orgSelectors } from 'ducks/orgs'
import { HardwareSupplierFilterKeyType } from 'opensolar-common/src/services/types/hardware'
import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { updateSelectedHardwareSupplier as updateSelectedHardwareSupplierDucks } from '../../../ducks/orderComponents'

const useHandleChangeSelectedDistributor = () => {
  const dispatch = useDispatch()
  const selectedSupplier = useSelector(orgSelectors.getSelectedHardwareSupplier)

  return useCallback(
    (desiredSupplier: HardwareSupplierFilterKeyType) => {
      if (desiredSupplier === selectedSupplier) {
        return
      }

      if (desiredSupplier) {
        dispatch(updateSelectedHardwareSupplierDucks(desiredSupplier))
        dispatch(updateRole({ user_data: { selected_hardware_supplier: desiredSupplier } }))
        dispatch(clearLineItems())
      }
    },
    [selectedSupplier, dispatch]
  )
}

export default useHandleChangeSelectedDistributor
